<ng-container [ngSwitch]="country">
	<!-- Argentina -->
	<ng-container *ngSwitchCase="ECountry.argentina">
		<span class="Flag Flag--argentina" [style.width.px]="width" [style.height.px]="height"></span>
	</ng-container>
	<!-- Colombia -->
	<ng-container *ngSwitchCase="ECountry.colombia">
		<span class="Flag Flag--colombia" [style.width.px]="width" [style.height.px]="height"></span>
	</ng-container>
	<!-- Mexico -->
	<ng-container *ngSwitchCase="ECountry.mexico">
		<span class="Flag Flag--mexico" [style.width.px]="width" [style.height.px]="height"></span>
	</ng-container>

	<ng-container *ngSwitchDefault
		>We don't have support for this country {{ country }}
	</ng-container>
</ng-container>
